import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';

import { StoreAttributes } from 'app/model';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';

interface AttributeGridProps extends Omit<DataGridProProps<StoreAttributes>, 'columns'> {
    rows: StoreAttributes[];
}

const columns: Array<GridColDef<StoreAttributes>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 150,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
    },
    {
        field: 'value',
        headerName: 'Value',
        width: 100,
        disableColumnMenu: true,
        editable: true,
        type: 'number',
    },
    {
        field: 'dateEdited',
        headerName: 'Date',
        width: 200,
        type: 'date',
        valueFormatter: DataGridFormatters.dateFormatter,
    },
    {
        field: 'details',
        headerName: 'Details',
        width: 200,
        editable: true,
    },
];

export class AttributeGrid extends React.Component<AttributeGridProps> {
    public render(): React.ReactNode {
        return (
            <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
                <DataGridPro {...this.props} columns={columns} />
            </Box>
        );
    }
}
